<template>
  <div>
    <div class="col-6 my-2">
      <v-select
        v-model="slugName"
        :items="slugList"
        item-text="name"
        item-value="slug"
        label="เลือกประเภท"
        outlined
        @change="getNumberTop()"
      />
    </div>

    <v-simple-table fixed-header>
      <template #default>
        <thead>
          <tr class="bg-dark">
            <th class="bg-dark text-center text-light">ประเภท</th>
            <th class="bg-dark text-center text-light">เลขแทง</th>
            <th class="bg-dark text-center text-light">ยอดแทง</th>
            <th class="bg-dark text-center text-light">ยอดถูก</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in numberTop" :key="item.id">
            <td class="text-center">
              {{ constants[item.slug] }}
            </td>
            <td class="text-center">
              {{ item.digits }}
            </td>
            <td>
              <span class="text-monospace text-center text-success d-block">
                {{ Intl.NumberFormat("en-US").format(item.amount) }}</span
              >
            </td>
            <td>
              <span class="text-monospace text-center text-success d-block">{{
                Intl.NumberFormat("en-US").format(item.prize)
              }}</span>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>

    <v-dialog v-if="preload" v-model="preload" persistent>
      <v-card class="pa-md-10 mx-lg-auto">
        <v-container class="text-center">
          <v-progress-circular
            :size="100"
            :width="10"
            indeterminate
            color="primary"
          />
        </v-container>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "TicketNumberAll",
  props: {
    gameId: { default: "", Type: Number },
  },
  data: () => ({
    slugName: "2upper",
    numberTop: [],
    constants: [],
    preload: false,
    slugList: [
      {
        slug: "2upper",
        name: "2บน",
      },
      {
        slug: "2under",
        name: "2ล่าง",
      },
      {
        slug: "3upper",
        name: "3บน",
      },
      {
        slug: "3shuffle",
        name: "3โต๊ด",
      },
      {
        slug: "3front",
        name: "3หน้า",
      },
      {
        slug: "3back",
        name: "3หลัง",
      },
      {
        slug: "any_upper",
        name: "วิ่งบน",
      },
      {
        slug: "any_under",
        name: "วิ่งล่าง",
      },
    ],
  }),
  computed: {},
  created() {
    this.getNumberTop();
  },
  methods: {
    getNumberTop() {
      if (this.gameId) {
        this.preload = true;
        axios
          .get(`/management/getDigitAll/${this.gameId}/${this.slugName}`)
          .then((response) => {
            this.numberTop = response.data.number;
            this.constants = response.data.constants;
          })
          .catch((e) => console.error(e))
          .finally(() => {
            this.preload = false;
          });
      }
    },
  },
};
</script>
